import React from "react";

const Message = ({ details }) => (
  <a className="dropdown-item d-flex align-items-center" href="/#">
    <div className="dropdown-list-image mr-3">
      <img
        className="rounded-circle"
        src={details.avatar ?? "https://source.unsplash.com/random/60x60"}
        alt=""
      />
      <div className="status-indicator bg-success"></div>
    </div>
    <div className={details.read ? "" : "font-weight-bold"}>
      <div className="text-truncate">{details.body}</div>
      <div className="small">
        {details.author} · {details.timeAgo}
      </div>
    </div>
  </a>
);

export default Message;
